import React from 'react';
import { Colors, Fonts } from '../../../../../shared/theme';

export default {
  marginBottom: {
    marginBottom: 0
  } as React.CSSProperties,
  inlineBlock: {
    display: 'inline-block'
  } as React.CSSProperties,
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  headerText: {
    fontSize: 24
  } as React.CSSProperties,
  icon: {
    width: 16,
    height: 16
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  tooltipText: {
    paddingTop: '12px',
    paddingRight: '5px',
    paddingLeft: '16px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  } as React.CSSProperties,
  remark: {
    marginTop: 8,
    whiteSpace: 'pre-line',
    color: Colors.font.primary.fakeBlack
  },
};
